module.exports = __webpack_public_path__ + "img/landingpage-video-simple-desktop.2690d232.svg";